/**
 * OrbDocCoreConceptsTraitsSLDocEx3TimingView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsSLDocEx3Timing
 */

import { useOrbDocCoreConceptsTraitsSLDocEx3TimingLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocEx3TimingLogic';
import type { OrbDocCoreConceptsTraitsSLDocEx3TimingConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocEx3TimingLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsSLStopwatch } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsSLDocEx3TimingViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsSLDocEx3TimingConfig>;
}

export function OrbDocCoreConceptsTraitsSLDocEx3TimingView({ config: propsConfig }: OrbDocCoreConceptsTraitsSLDocEx3TimingViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsSLDocEx3TimingLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsSLStopwatch'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsSL" trait="OrbDocCoreConceptsTraitsSLDocEx3Timing">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Start" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx3Timing.START" variant="primary" /><Button label="Reset" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx3Timing.RESET" variant="ghost" /></Stack>) : slotWriter['main'] === 'START' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Stop" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx3Timing.STOP" variant="secondary" /></Stack>) : slotWriter['main'] === 'STOP' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Start" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx3Timing.START" variant="primary" /><Button label="Reset" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx3Timing.RESET" variant="ghost" /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsSLDocEx3TimingView;
